export const migrateConfig = [
    {
        nyckel: "lager_ppl",
        migrateinfo: [
            {
                id: "ppl-restriktioner-extern-40",
                layerid: "Restriktioner",
                sourcesublayerid: 2,
                destinationsublayerid: 3
            },
            {
                id: "ppl-restriktioner-svea",
                layerid: "Restriktioner",
                sourcesublayerid: 3,
                destinationsublayerid: 4
            },
            {
                id: "ppl-restriktioner-extern-100",
                layerid: "Restriktioner",
                sourcesublayerid: 4,
                destinationsublayerid: 5
            },
            {
                id: "ppl-restriktioner-extern-50",
                layerid: "Restriktioner",
                sourcesublayerid: 5,
                destinationsublayerid: 6
            },
            {
                id: "ppl-restriktioner-ifl",
                layerid: "Restriktioner",
                sourcesublayerid: 6,
                destinationsublayerid: 7
            },
            {
                id: "ppl-laserprodukter-lutningsklass",
                layerid: "Laserprodukter",
                sourcesublayerid: 0,
                destinationsublayerid: 2
            },
            {
                id: "ppl-laserprodukter-skuggad",
                layerid: "Laserprodukter",
                sourcesublayerid: 1,
                destinationsublayerid: 4
            },
            {
                id: "ppl-laserprodukter-trahojdraster",
                layerid: "Laserprodukter",
                sourcesublayerid: 2,
                destinationsublayerid: 3
            },
            {
                id: "ppl-laserprodukter-skuggadkronmodell",
                layerid: "Laserprodukter",
                sourcesublayerid: 3,
                destinationsublayerid: 1
            },
            {
                id: "ppl-markvattenslu",
                layerid: "Laserprodukter",
                sourcesublayerid: 0,
                destinationsublayerid: 9
            },
            {
                id: "ppl-laserprodukter-markfuktighet",
                layerid: "Laserprodukter",
                sourcesublayerid: 4,
                destinationsublayerid: 5
            },
            {
                id: "ppl-laserprodukter-mkt-blot",
                layerid: "Laserprodukter",
                sourcesublayerid: 5,
                destinationsublayerid: 8
            },
            {
                id: "ppl-laserprodukter-blot",
                layerid: "Laserprodukter",
                sourcesublayerid: 6,
                destinationsublayerid: 7
            },
            {
                id: "ppl-laserprodukter-normalt",
                layerid: "Laserprodukter",
                sourcesublayerid: 7,
                destinationsublayerid: 6
            },
            {
                id: "ppl-laserprodukter-kronslutenhet",
                layerid: "Laserprodukter",
                sourcesublayerid: 8,
                destinationsublayerid: 0
            }
        ]
    },
    {
        nyckel: "lager_virkeskop",
        migrateinfo: [
            {
                id: "vk-restriktioner-extern-40",
                layerid: "Restriktioner",
                sourcesublayerid: 2,
                destinationsublayerid: 3
            },
            {
                id: "vk-restriktioner-svea",
                layerid: "Restriktioner",
                sourcesublayerid: 3,
                destinationsublayerid: 4
            },
            {
                id: "vk-restriktioner-extern-100",
                layerid: "Restriktioner",
                sourcesublayerid: 4,
                destinationsublayerid: 5
            },
            {
                id: "vk-restriktioner-extern-50",
                layerid: "Restriktioner",
                sourcesublayerid: 5,
                destinationsublayerid: 6
            },
            {
                id: "vk-restriktioner-ifl",
                layerid: "Restriktioner",
                sourcesublayerid: 6,
                destinationsublayerid: 7
            },
            {
                id: "vk-laserprodukter-lutningsklass",
                layerid: "Laserprodukter",
                sourcesublayerid: 0,
                destinationsublayerid: 2
            },
            {
                id: "vk-laserprodukter-skuggad",
                layerid: "Laserprodukter",
                sourcesublayerid: 1,
                destinationsublayerid: 4
            },
            {
                id: "vk-laserprodukter-trahojdraster",
                layerid: "Laserprodukter",
                sourcesublayerid: 2,
                destinationsublayerid: 3
            },
            {
                id: "vk-laserprodukter-skuggadkronmodell",
                layerid: "Laserprodukter",
                sourcesublayerid: 3,
                destinationsublayerid: 1
            },
            {
                id: "vk-markvattenslu",
                layerid: "Laserprodukter",
                sourcesublayerid: 0,
                destinationsublayerid: 9
            },
            {
                id: "vk-laserprodukter-markfuktighet",
                layerid: "Laserprodukter",
                sourcesublayerid: 4,
                destinationsublayerid: 5
            },
            {
                id: "vk-laserprodukter-mkt-blot",
                layerid: "Laserprodukter",
                sourcesublayerid: 5,
                destinationsublayerid: 8
            },
            {
                id: "vk-laserprodukter-blot",
                layerid: "Laserprodukter",
                sourcesublayerid: 6,
                destinationsublayerid: 7
            },
            {
                id: "vk-laserprodukter-normalt",
                layerid: "Laserprodukter",
                sourcesublayerid: 7,
                destinationsublayerid: 6
            },
            {
                id: "vk-laserprodukter-kronslutenhet",
                layerid: "Laserprodukter",
                sourcesublayerid: 8,
                destinationsublayerid: 0
            }
        ]
    }
];
